import React from "react"
import PrivacyText from "./PrivacyText"
import defaultPrivacy from "../assets/PrivacyText.txt"

function PrivacyModal({ visible, closeModal, textFile = defaultPrivacy }) {
  return (
    // MODAL VIEW
    <div
      className={
        visible
          ? "modal-view modal-view-visible"
          : "modal-view modal-view-hidden"
      }
    >
      {/* MODAL */}
      <div
        className={visible ? "modal modal-slide-up" : "modal modal-slide-down"}
      >
        <div className="modal-title">
          <h1>Privacy Policy</h1>
        </div>
        <div className="modal-container">
          <PrivacyText textFile={textFile} />
        </div>
        <div className="modal-footer">
          <button type="button" className="modal-done-btn" onClick={closeModal}>
            Done
          </button>
        </div>
      </div>
    </div>
  )
}

export default PrivacyModal
